export enum TaskMode {
  'CREATE' = 'CREATE',
  'UPDATE' = 'UPDATE',
  'VIEW' = 'VIEW',
}
